import { getLullabies } from "src/modules/lullaby/ajax/cloud";
import debug from "src/modules/debug-logger";
import lullabyFiles from "src/modules/lullaby/lullaby-files";

import { replaceLullabies } from "../actions";

export default function synchronizeLullabies() {
  return async (dispatch, getState) => {
    const lullabiesArray = await getLullabies();
    const savedLullabies = lullabyFiles.getFilenames();

    const lullabies = lullabiesArray.reduce(function arrayToObject(
      lullabiesObj,
      lullaby
    ) {
      lullabiesObj[lullaby.objectId] = lullaby;
      return lullabiesObj;
    },
    {});
    dispatch(replaceLullabies(lullabies));

    savedLullabies?.forEach(function deleteIfUnused(filename) {
      const isInUse = lullabiesArray.some(({ audioFile }) => {
        return audioFile ? audioFile.name === filename : false;
      });
      if (isInUse === false) {
        debug.synchronizer("About to delete lullaby audio", filename);
        lullabyFiles.delete(filename);
      }
    });
  };
}
